import { Box } from '@material-ui/core';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import {
  NIE_EU_CARD_ID,
  NIE_EU_EXPIRATION_DATE_CARD_DATE,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/constants/nieEuData.constants';
import { isNieEuDocumentType } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/utils/nieDocumentTypes.utils';
import { useShowMerchantPosNieDataFields } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/_shared/hooks/useShowMerchantPosNieDataFields';
import { getNieDataFormDisplayValues } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/_shared/maps/nieDataForm.map';
import { FormSectionWrapper } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/_shared/FormSectionWrapper';
import { BorrowerOnboardingDetailsFormType } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/BorrowerOnboardingDetailsForm/schemas/borrowerOnboardingDetailsForm.schema';
import {
  DocumentIdForm as DocumentId,
  DocumentIdFormProps,
} from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/components/DocumentIdForm';
import { NieDataForm } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/components/NieDataForm';
import { Font } from '@/components/shared/components/Font';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';

export const DocumentIdForm = ({ fieldVariant, fullWidth, direction }: DocumentIdFormProps) => {
  const { watch, setValue } = useFormContext<BorrowerOnboardingDetailsFormType>();
  const documentType = watch('documentType');
  const showNieDataFields = useShowMerchantPosNieDataFields(documentType);
  const isFormVariant = fieldVariant === FieldVariant.form;

  useEffect(() => {
    if (!isNieEuDocumentType(documentType)) {
      return;
    }

    setValue('cardId' as keyof BorrowerOnboardingDetailsFormType, NIE_EU_CARD_ID);
    setValue('expirationDateCard' as keyof BorrowerOnboardingDetailsFormType, NIE_EU_EXPIRATION_DATE_CARD_DATE);
  }, [documentType, setValue]);

  const nieData = !isFormVariant
    ? getNieDataFormDisplayValues({
        nationalityPeriod: watch('nationalityPeriod'),
        cardId: watch('cardId'),
        expirationDateCard: watch('expirationDateCard'),
        socialSecurityDate: watch('socialSecurityDate'),
        numberOfWork: watch('numberOfWork'),
      })
    : undefined;

  return (
    <FormSectionWrapper titleTid="DOCUMENT_ID" subtitleTid="DOCUMENT_ID_FORM_INFO">
      <Box pt={2}>
        <DocumentId
          showBirthDateField
          fieldVariant={fieldVariant}
          fullWidth={fullWidth}
          direction={direction ?? 'row'}
        />
        {showNieDataFields && (
          <Box pt={4}>
            <Font variant="subtitle2" color="secondary">
              <Text strong tId="NIE_DATA" />
            </Font>
            <Box pt={3} />
            <NieDataForm
              documentType={documentType}
              nieData={nieData}
              fieldVariant={fieldVariant}
              fullWidth={fullWidth}
              direction={direction}
            />
          </Box>
        )}
      </Box>
    </FormSectionWrapper>
  );
};
